import { combineReducers } from 'redux';
import purchaseButtonInfo from './purchaseButtonInfo';
import workflowStart from './workflowStart';
import purchaseConfirmation from './confirm';
import currentPayment from './currentPayment';
import whatIncludes from './whatIncludes';

export default combineReducers({
  purchaseButtonInfo,
  workflowStart,
  purchaseConfirmation,
  currentPayment,
  whatIncludes,
});
